export class CardStatus{
    id: number;
    name: string;
}

export class CustomerProfileCard {
    id: number;
    number: number;
    holderName: string;
    validity: string;
    status: CardStatus;
    currency: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/api/entity/customer-profile-cards.ts